module.exports = __webpack_public_path__ + "img/It’s time to talk about sexual health.f1040f68.jpg";